import { render, staticRenderFns } from "./sp-login.vue?vue&type=template&id=ad8631ce&scoped=true"
import script from "./sp-login.vue?vue&type=script&lang=js"
export * from "./sp-login.vue?vue&type=script&lang=js"
import style0 from "./sp-login.vue?vue&type=style&index=0&id=ad8631ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8631ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad8631ce')) {
      api.createRecord('ad8631ce', component.options)
    } else {
      api.reload('ad8631ce', component.options)
    }
    module.hot.accept("./sp-login.vue?vue&type=template&id=ad8631ce&scoped=true", function () {
      api.rerender('ad8631ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sp-login.vue"
export default component.exports